/* Copyright (c) 2021-2022 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const ServiceShortInitialState = {
  id: "",
  name: "",
  version: "",
  services: [
    {
      id: "",
      name: "",
      pricingType: "",
      version: "",
    },
  ],
};

export const serviceInitialLoadingState = {
  name: false,
  pricingType: false,
  processType: false,
  serviceLevelId: false,
  serviceLines: false,
  version: false,
  ownerId: false,
  description: false,
  prerequisites: false,
};
